import { render, staticRenderFns } from "./FarmaciaReporteMovs.vue?vue&type=template&id=6fb6b8d3&"
import script from "./FarmaciaReporteMovs.vue?vue&type=script&lang=js&"
export * from "./FarmaciaReporteMovs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports